import React, { useEffect } from "react";
import IconBeneficiario from "../../Resources/svg/Icons/IconBeneficiario";
import ErrorCustom from "../../Components/errorCustom";
import { Controller, useFormContext } from "react-hook-form";
import NumberFormat from "react-number-format";
import { validateOnlyNumbers } from "../../Utils/validators";

interface Props {
  disableRemove: boolean;
  legalEntitiesData: Array<any>;
  legalEntity: Object;
  index: number;
  removeLegalEntity: Function;
  count: number;
}

export const LegalEntityForm = ({
  disableRemove,
  legalEntitiesData,
  legalEntity,
  index,
  removeLegalEntity,
  count,
}: Props) => {
  const methods = useFormContext();
  const { register, errors, watch, setValue, control } = methods;

  const companyNameControl = legalEntitiesData
    .flatMap((item) => item.childControls ? item.childControls : [item])
    .find((child) => child.metadata.placeholder === "Razón social");

  const rucControl = legalEntitiesData
    .flatMap((item) => item.childControls ? item.childControls : [item])
    .find((child) => child.metadata.placeholder === "RUC");

  const percentageParticipationControl = legalEntitiesData
    .flatMap((item) => item.childControls ? item.childControls : [item])
    .find((child) => child.metadata.placeholder === "% de Participación");

  
  const companyNameSk = Object.keys(legalEntity)[0];
  const rucSk = Object.keys(legalEntity)[1];
  const percentageParticipationSk = Object.keys(legalEntity)[2];

  const validateOptionalFields = (value: any, type: any) => {
      if (!value || value == "") return "*Revisa los datos ingresados.";
      switch (type) {
        case "RUC":
          if (value.length !== 11) {
            return "*Revisa los datos ingresados.";
          }
          if (!validateOnlyNumbers(value)) return "El campo debe contener solo números";
          break;
        case "% de Participación":
          if (parseFloat(value) < 25 || parseFloat(value) > 100) return "Ingrese un porcentaje válido";
          if (!validateOnlyNumbers(value)) return "El campo debe contener solo números";
          break;
        case "Razón social":
          if (value === "") return "*Revisa los datos ingresados.";
          break;
        default:
          return true;
      }
    
      return true;
    };

  const remove = (e: any) => {
    e.preventDefault();
    if(disableRemove) return;
    removeLegalEntity(index);
  }; 

  return (
    <>
      <div
        className={`beneficiaryForm${index === 0 ? " first" : ""}`}
        style={{ position: "relative" }}
      >
        <div className="clientForm__beneficiary-box">
          <div className="clientForm__beneficiary-box-icon">
            <IconBeneficiario />
            <div className="clientForm__beneficiary">
              Persona Jurídica {(index+1) + 1}
            </div>
          </div>
          {count > 0 && (
            <p
              className={`clientForm__eliminar ${disableRemove ? "disabled-action" : ""}`}
              onClick={(e) => {
                remove(e);
              }}
            >
              Eliminar
            </p>
          )}
        </div>
      </div>

      {legalEntitiesData[0] && (
        <>
          <div className="question__control input-field">
            <input
              type="text"
              autoComplete="off"
              id={companyNameSk}
              name={companyNameSk}
              ref={register({
                validate: (value) => validateOptionalFields(value, "Razón social"),
              })}
              maxLength={companyNameControl.metadata.maxLength}
            />
            <label htmlFor={companyNameSk}>
              {companyNameControl.metadata.placeholder}
            </label>
          </div>
          <ErrorCustom
            errors={errors}
            name={companyNameSk}
          />
        </>
      )}

      {legalEntitiesData[1] && (
        <>
          <div className="question__control input-field">
            <Controller
              autoComplete="off"
              as={NumberFormat}
              id={rucSk}
              name={rucSk}
              control={control}
              maxLength={rucControl.metadata.maxLength}
              rules={{
                validate: (value) => validateOptionalFields(value, "RUC"),
              }}
            />
            <label htmlFor={rucSk}>
              {rucControl.metadata.placeholder}
            </label>
          </div>
          <ErrorCustom
            errors={errors}
            name={rucSk}
          />
        </>
      )}

      {legalEntitiesData[2] && (
        <>
          <div className="question__control input-field percent">
            <Controller
              autoComplete="off"
              as={NumberFormat}
              id={percentageParticipationSk}
              name={percentageParticipationSk}
              control={control}
              maxLength={percentageParticipationControl.metadata.maxLength}
              rules={{
                required: true,
                validate: (value) => validateOptionalFields(value, "% de Participación"),
              }}
            />
            {percentageParticipationControl.metadata.placeholder ===
              "% de Participación" && (
              <span className="tooltip">
                El valor ingresado debe estar
                entre 25% y 100%.
              </span>
            )}
            <label htmlFor={percentageParticipationSk}>
              {percentageParticipationControl.metadata.placeholder}
            </label>
          </div>
          <ErrorCustom
            errors={errors}
            name={percentageParticipationSk}
          />
        </>
      )}
    </>
  );
};
